























































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  GetBindingLaboratoryIndicatorsList,
  GetLaboratoryIndicatorsList
} from "@/api/laboratoryCategories";
import bindingLaboratoryIndicators from "./bindingLaboratoryIndicators.vue";
import saveLaboratoryIndicators from "./saveLaboratoryIndicators.vue";
@Component({
  components: {bindingLaboratoryIndicators,saveLaboratoryIndicators },
})
export default class extends AbpBase {
    cateData: any = [];//化验指标数据
    itemData: any = [];//绑定指标数据
    cateLoading: boolean = false;//化验指标加载
    itemLoading: boolean = false;//绑定指标加载
    indicators: any = null; //当前选中的指标
    adjustItemData: any; //调整的指标
    adjustItemShow: boolean = false;//调整指标页面
    showLaboratoryIndicators: boolean = false;//修改指标页面
    laboratoryIndicatorsData:any={};
    title="";
    queryString="";
    //化验指标标题
    cateColumns = [
        {
            title: "指标编码",
            key: "itemCode",
            minWidth: 120,
        },
        {
            title: "指标名称",
            key: "itemName",
            width: 120,
        },
        {
            title: "单位",
            key: "unit",
            width: 80,
        },
        {
            title: "样本",
            key: "sampleClass",
            minWidth: 80,
        },
        {
            title: "最大值",
            key: "maximum",
            width: 100,
        },
        {
            title: "最小值",
            key: "minimum",
            width: 100,
        },
        {
            title: "排序码",
            key: "sortNum",
            width: 100,
        },
         {
            title: "操作",
            width: 120,
            render: (h1: any, params: any) => {
                const h = this.$createElement;
                let isdefaultDom: any;
                return h("div", [
                    isdefaultDom,
                    h(
                        "Button",
                        {
                        props: {
                            type: "primary",
                            size: "small",
                        },
                        style: {
                            marginRight: "15px",
                        },
                        on: {
                            click: () => {
                                this.editData(params.row);
                            },
                        },
                        },
                        "编辑"
                    ),
                ]);
            },
        },
    ];
    //绑定指标标题
    itemColumns = [
        {
            title: "指标编码",
            key: "itemCode",
            minWidth: 120,
        },
        {
            title: "指标名称",
            key: "itemName",
            minWidth: 120,
        },
        {
            title: "单位",
            key: "unit",
            width: 80,
        },
        {
            title: "样本",
            key: "sampleClass",
            minWidth: 80,
        },
        {
            title: "换算",
            key: "conversion",
            width: 80,
        },
        {
            title: "值类型",
            key: "valueType",
            width: 120,
        },
    ];
    created() 
    {
        this.getCateList();
    }
    refreshData()
    {
        this.getCateList();
    }
    handleCateClick(row: any) {
        this.indicators = row;
        this.title = row.itemName
        this.getItemList();
    }
    async getItemList() {
        if (!this.indicators) {
            return;
        }
        this.itemLoading = true;
        let res = await GetBindingLaboratoryIndicatorsList({
            indicatorsId: this.indicators.id,
        });
        this.itemLoading = false;
        this.itemData = res.objects;
    }
    async getCateList() {
        this.cateLoading = true;
        this.indicators={};
        let res = await GetLaboratoryIndicatorsList({queryString:this.queryString });
        this.cateLoading = false;
        this.cateData = res.objects;
    }
    adjustItem() {
      if (!this.indicators) {
        return;
      }
      this.adjustItemData = {
        mode: "add",
        indicatorsId: this.indicators.id,
        itemName: this.indicators.itemName,
        fuzzyQuery: this.indicators.fuzzyQuery,
      };
      this.adjustItemShow = true;
    }
    editData(row: any) {
        this.laboratoryIndicatorsData= row;
        this.laboratoryIndicatorsData.title = "编辑";
        this.showLaboratoryIndicators=true;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/laboratoryCategories/index.vue